const STORAGE_KEY_PREFIX = 'eagle_last_order_type_id_';

export function getLastUsedOrderTypeId(workspaceId) {
  if (!workspaceId) return '';
  try {
    return localStorage.getItem(`${STORAGE_KEY_PREFIX}${workspaceId}`) || '';
  } catch (_) {
    return '';
  }
}

export function setLastUsedOrderTypeId(workspaceId, typeId) {
  if (!workspaceId || !typeId) return;
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${workspaceId}`, String(typeId));
  } catch (_) {}
}

/** Resolve which active type to use: explicit preference, then last used, then general / first. */
export function pickActiveOrderTypeId(activeTypes, preferredId, lastUsedId) {
  const list = activeTypes || [];
  const isValid = (id) => Boolean(id && list.some((t) => t.id === id));
  if (isValid(preferredId)) return preferredId;
  if (isValid(lastUsedId)) return lastUsedId;
  const g = list.find((t) => t.slug === 'general');
  return (g || list[0])?.id || '';
}
